import { createSlice } from '@reduxjs/toolkit';

const initialState = {
  userPermissions: [],
  permissions: [],
};

const slice = createSlice({
  name: 'authorization',
  initialState: initialState,
  reducers: {
    setUserPermissions: (state, { payload }) => {
      return {
        ...state,
        userPermissions: payload ? [...payload, { name: 'Dummy' }] : [],
      };
    },
    setPermissions: (state, { payload }) => {
      return {
        ...state,
        permissions: payload,
      };
    },
    resetPermissions: () => {
      return initialState;
    },
  },
});

export const { setUserPermissions, setPermissions } = slice.actions;

export default slice.reducer;
